import BaseService from '../../../services/BaseService';

export const EXTRATO_DEFAULT_PAGE_SIZE = 10;

const toIsoDate = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const buildExtratoMovimentacaoUrl = (produtoId, {
  page = 0,
  size = EXTRATO_DEFAULT_PAGE_SIZE,
  local,
  dataInicio,
  dataFim,
} = {}) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('size', String(size));
  params.set('p', String(page));
  params.set('s', String(size));
  if (local) params.set('local', local);
  const inicio = toIsoDate(dataInicio);
  const fim = toIsoDate(dataFim);
  if (inicio) params.set('dataInicio', inicio);
  if (fim) params.set('dataFim', fim);
  return `produtos/${encodeURIComponent(produtoId)}/extrato-movimentacao?${params.toString()}`;
};

export const parseExtratoMovimentacaoResponse = (data) => {
  if (Array.isArray(data)) {
    return {
      mode: 'list',
      rows: data,
      totalRows: data.length,
    };
  }
  const rows = data?.content ?? data?.rows ?? [];
  const totalRows = data?.totalElements ?? data?.totalRows ?? rows.length;
  const isPage = data != null && (
    Array.isArray(data.content)
    || data.totalElements != null
    || (Array.isArray(data.rows) && data.totalRows != null)
  );
  return {
    mode: isPage ? 'page' : 'list',
    rows: Array.isArray(rows) ? rows : [],
    totalRows,
  };
};

export const mapExtratoRow = (row, index) => ({
  ...row,
  id: row.pedidoItemId || row.id || `${row.pedidoId || 'item'}-${index}`,
});

export async function fetchExtratoMovimentacao(produtoId, params) {
  const response = await BaseService.get({
    url: buildExtratoMovimentacaoUrl(produtoId, params),
  });
  return parseExtratoMovimentacaoResponse(response?.data);
}
